import { Box, ConditionWrapper, Flex, Form, Text, TextField } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { constants } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch, useSelector } from 'modules/react-redux';
import { SectionContainer } from 'pages/requestForm/components/SectionContainer';
import { FC, memo, useEffect } from 'react';
import bemFactory from 'react-bem-factory';
import { useForm } from 'react-hook-form';
import { useUserBetaFeatures } from 'shared/hooks';
import { ocrIsLoadingState } from 'shared/states';

import { changeQbooksVendorMessage } from '../../../actions';
import { getRequest } from '../../../selectors/pageSelectors';
import { vendorMessageFieldName } from './QBooksVendorMessageSection.constants';
import { messages } from './QBooksVendorMessageSection.messages';
import { QBooksVendorMessageSectionProps } from './QBooksVendorMessageSection.types';

const qa = bemFactory.qa('reqf-qbooks-vendor-message-section');

export const QBooksVendorMessageSection: FC<QBooksVendorMessageSectionProps> = memo((props) => {
    const { noPadding } = props;

    const dispatch = useDispatch();
    const request = useSelector<domain.QBooksPoRequest>(getRequest);
    const ocrIsLoading = useAtomValue(ocrIsLoadingState);

    const { isBelgradeUIVendorMessageSection } = useUserBetaFeatures();

    const form = useForm({
        defaultValues: {
            [vendorMessageFieldName]: request.details.vendorMessage || '',
        },
    });

    const fieldVendorMessage = form.watch(vendorMessageFieldName);

    useEffect(() => {
        if (form.formState.isDirty) {
            dispatch(changeQbooksVendorMessage(fieldVendorMessage));
        }
    }, [dispatch, fieldVendorMessage, form.formState.isDirty]);

    return (
        <Box width='100%'>
            <Form form={form}>
                <ConditionWrapper
                    condition={isBelgradeUIVendorMessageSection}
                    wrapperIf={(children) => (
                        <Flex direction='column'>
                            <Text font='headline' fontSize='xxsmall' fontWeight='medium' uppercase>
                                {messages.title}
                            </Text>

                            {children}
                        </Flex>
                    )}
                    wrapperElse={(children) => (
                        <SectionContainer noPadding={noPadding} qa={qa()} title={messages.title}>
                            {children}
                        </SectionContainer>
                    )}
                >
                    <TextField
                        qa={qa('vendor-message-editor')}
                        name={vendorMessageFieldName}
                        multiline
                        autoHeight
                        maxLength={constants.qBooksConstants.VENDOR_MESSAGE_MAX_LENGTH}
                        placeholder={messages.placeholder}
                        minHeight={124}
                        maxHeight={252}
                        disabled={ocrIsLoading}
                    />
                </ConditionWrapper>
            </Form>
        </Box>
    );
});

QBooksVendorMessageSection.displayName = 'QBooksVendorMessageSection';
